import isEmptyValue from './isEmptyValue';

export default function getValue(node) {
  return !isEmptyValue(node.props.value)
    ? node.props.value
    : node.props.children;
}
